import React, { useState } from 'react';
import { Button, Icon, Header, Modal } from 'semantic-ui-react';
import PopupButton from '../../../../components/PopupButton/PopupButton';

const DetailsModal = ({ children }) => {
  const [open, setOpen] = useState(false);

  // Modal Actions

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Modal
      dimmer="inverted"
      trigger={
        <PopupButton
          id="details-modal"
          basic
          icon="edit outline"
          color="teal"
          title="Details"
          onClick={() => {}}
        />
      }
      open={open}
      onOpen={handleOpen}
      onClose={handleClose}
    >
      <Header content="Details" />
      <Modal.Content>{children}</Modal.Content>
      <Modal.Actions>
        <Button basic color="teal" onClick={handleClose}>
          <Icon name="remove" /> Close
        </Button>
      </Modal.Actions>{' '}
    </Modal>
  );
};

export default DetailsModal;
